import {Product} from "./Product";
export class ProductAndNumber {
    product: Product;
    number: number;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/ProductAndNumber.ts